export default __webpack_public_path__ + "static/media/question-hero.a338dae4.svg";